import React from "react";
import { LayoutMain } from "@unisearch/theme/layout";
import { CareerHero, CareerJobs } from "@modules/study/careers/home";
import API from "@unisearch/helpers/api";

const Careers = ({ jobs }) => {
  return (
    <LayoutMain
      title="Careers"
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/career`}
    >
      <CareerHero />
      <CareerJobs jobs={jobs} />
    </LayoutMain>
  );
};

export default Careers;

export async function getServerSideProps({ params }) {
  let jobs = [];

  try {
    const jobList = await API.get(`/public/career-post`);

    if (jobList.data) {
      jobs = jobList.data;
    }

    return {
      props: {
        jobs,
      },
    };
  } catch (err) {
    return {
      props: {
        jobs,
      },
    };
  }
}
